<template>
  <div class="refList">
    <div class="tableSecondElement">
      <table class="table table-bordered table-striped table-hover table-sm">
        <thead>
          <tr>
            <th v-for="field in fields" :key="field.key" class="text-center align-middle">{{ field.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="reference in refsApp" :key="reference.idRef">
            <td class="text-center">{{ reference.idRef }}</td>
            <td class="text-center">{{ reference.titre }}</td>
            <td class="text-center">{{ reference.type }}</td>
            <td class="text-center">{{ reference.document }}</td>
            <td class="text-center">{{ reference.annee }}</td>
            <td class="text-center"><a @click="supprimerRef(reference)" class="icon_delete" title="supprimer la référence"><i class="fa-solid fa-trash-can"></i></a></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, toRefs } from 'vue';

export default defineComponent({
  name: "RefBibliosList",

  props:{
    refsApp:{
      type:Array,
      required:true
    },

    lectureSeule:{
      type:Boolean,
      default:true
    }
  },

  setup(props, { emit }) {
    const fields = ref([
      {key: 'idRef', label:'Id', class: 'text-center'},
      {key: 'titre', label:'Titre', class: 'text-center'},
      {key: 'type', label:'Type réf', class: 'text-center'},
      {key: 'document', label:'Doc. source', class: 'text-center'},
      {key: 'annee', label:'Année publi.', class: 'text-center'},
      { key: "actions", label: "Actions", class: "text-center" }
    ]);

    const supprimerRef = (reference) => {
      emit("deleteRef", reference);
    };

    return {
      ...toRefs(props),
      fields,
      supprimerRef
    };
  }
});
</script>
<style scoped>

</style>